import isEqual from 'lodash-es/isEqual';
import { useRef } from 'react';

/**
 * 返回值的稳定引用：仅当深比较发现值变化时才更新引用。
 * 用于 useEffect / useMemo 依赖，避免对象引用变化但值未变时重复触发。
 *
 * 单值: useStableValue(params)
 * 多值: useStableValues(filter, sortBy) → [stableFilter, stableSortBy]
 */
export function useStableValue<T>(value: T): T {
  const ref = useRef<T>(value);
  if (!isEqual(ref.current, value)) {
    ref.current = value;
  }
  return ref.current;
}

/** 多值版本：对每个值独立做深比较，返回稳定引用的元组 */
export function useStableValues<T extends any[]>(...values: T): T {
  const ref = useRef<T>(values);
  const next = values.map((val, i) =>
    isEqual(ref.current[i], val) ? ref.current[i] : val,
  ) as T;
  ref.current = next;
  return next;
}
